// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chevron-left.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/chevron-left'

import { Icon, type IconComponentProps } from '../icon'

export const ChevronLeftIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
